import { ErrorType } from '../types/response';

/**
 * レスポンスコード
 */
// レスポンスコード（メンテナンス）
export const ERROR_MAINTENANCE: ErrorType = {
  statusCode: 503,
  message: 'Under Maintenance',
  code: 1,
};

// レスポンスコード（アプリのQPS制限）
export const ERROR_OVER_QPS: ErrorType = {
  statusCode: 503,
  message: 'Too many requests, please try again later.',
  code: 2,
};

// レスポンスコード（バージョンアップのための強制リロード）
export const ERROR_APP_UPGRADE: ErrorType = {
  statusCode: 400,
  message: 'Client Upgrade Required',
  code: 3,
};

export enum ClientType {
  INVALID = 'invalid',
  USER = 'user',
  MERCHANT = 'merchant',
  BOT = 'bot',
}

export enum AnnouncementTypeEnum {
  Notice = 0,
  Warning = 1,
}

export const NO_IMAGE_URL =
  'https://thumbnail.image.rakuten.co.jp/@0_mall/com/entf/asset/img/no_image.jpg';

export const CLOSED_SHOP_FAQ_URL =
  'https://ichiba.faq.rakuten.net/detail/000032096';
